import { render } from "./AdminAboutus.vue?vue&type=template&id=29ae7094&lang=true"
import script from "./AdminAboutus.vue?vue&type=script&lang=js"
export * from "./AdminAboutus.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__